<template>
	<div style="width: 100%;height: 100%;">
		<div v-if="AttendContextShow" style="height: 100%;background: rgba(226, 238, 248, 1);">
			<Row type="flex" justify="center" align="middle" style="height: 86px;background: beige;">
				<Col span="4" >
				</Col>
				<Col span="15">
					<div style="font-size: 16px;text-align: center;">{{formMeeting.msubject}}
					</div>
					<div style="text-align: center;">
						<span style="font-size:12px;-webkit-transform-origin-x: 0;-webkit-transform: scale(0.90);">
							<DateTime :loading="true" :stime="formMeeting.mstime" :etime="formMeeting.metime"></DateTime>
							<Tooltip v-if="register" content="迟到模式" placement="top" :transfer="true">
								<Icon size="12" style="margin-top: -15px;margin-left: -4px;" type="md-stopwatch" />
							</Tooltip>
						</span>
						</div>
				</Col>
				<Col span="5">
					
				</Col>
			</Row>
			<Row type="flex" justify="center" align="middle" style="margin-top: -18px;height: 38px;background: beige;">
				<Col span="17" >
					<div style="text-align: left;height: 14px;">
						<Icon style="margin-top: -4px;" size="20" type="ios-pin" />
						{{formMeeting.maddress}}
					</div>
				</Col>
				<Col span="3" style="text-align: center;">
					 <Poptip v-if="!formMeeting.allStatus&&!repeatOperation&&!endMeeting" placement="bottom" width="160" padding="0px 0px">
						<Button size="small" type="info" shape="circle">备注</Button>
						<Input slot="content" v-model="formMeeting.allremark" style="width: 100%;" :rows="3" type="textarea" placeholder="这里输入请假的理由" />
					 </Poptip>
				</Col>
				<Col span="4" style="text-align: center;">
					<i-switch v-if="!repeatOperation&&!endMeeting&&!concelMeeting" size="large" v-model="formMeeting.allStatus" >
						<span slot="open">参加</span>
						<span slot="close">请假</span>
					</i-switch>
				</Col>
			</Row>
			<div style="width: 100%;height: 480px;padding: 10px 0px;overflow:auto">
				<Row v-for="(item,index) in meetingTimes" :key="index" type="flex" justify="center" align="middle" style="height: 69px;background: white;margin-bottom: 10px;">
					<Col span="3" style="text-align: right;">
						阶段{{index+1}}
					</Col>
					<Col span="2">
						<Tooltip v-if="item.mtRegister" content="迟到模式" placement="top" :transfer="true">
							<Icon size="14" style="margin-top: -15px;" type="md-stopwatch" />
						</Tooltip>
					</Col>
					<Col span="12">
						<div style="height:21px;width: 100%;font-size: 14px;overflow: hidden;">
							{{item.mtName}}
						</div>
						<div style="height:16px;width: 100%;overflow: hidden;">
							<div style="font-size:12px;-webkit-transform-origin-x: 0;-webkit-transform: scale(0.90);">
								<Tooltip content="会议时间" :transfer="true" placement="top"> 
									<Icon size="16" type="md-time" style="margin-top: -3px;margin-right: 2px;"  />
									<DateTime type="dhm" :spliceShow="false"  :stime="item.mtStime" :etime="item.mtEtime"></DateTime>
									
								</Tooltip>
							</div>
						</div>
						<div  v-if="item.mtRstime!=''&&item.mtRetime!=''" style="height:16px;width: 100%;overflow: hidden;font-size: 12px;-webkit-transform-origin-x: 0;-webkit-transform: scale(0.90);">
							<Tooltip content="签到时间" :transfer="true" placement="top">
								<Icon size="16" type="md-stopwatch" style="margin-top: -3px;margin-right: 2px;" />
								<DateTime type="hm" :spliceShow="false" :stime="item.mtRstime" :etime="item.mtRetime"></DateTime>
							</Tooltip>
						</div>
					</Col>
					<Col span="3" style="text-align: center;">
						<Poptip v-if="!item.rstatus&&!repeatOperation&&!endMeeting&&!concelMeeting" placement="bottom" width="160" padding="0px 0px">
							<Button size="small" type="info" shape="circle">备注</Button>
							<Input slot="content" v-model="item.rcase" style="width: 100%;" :rows="3" type="textarea" placeholder="这里输入请假的理由" />
						</Poptip>
					</Col>
					<Col span="4" style="text-align: center;">
						<i-switch v-if="!repeatOperation&&!endMeeting&&!concelMeeting" size="large" v-model="item.rstatus" >
							<span slot="open">参加</span>
							<span slot="close">请假</span>
						</i-switch>
					</Col>
				</Row>
			</div>
			<Row type="flex" justify="center" align="middle" style="height: 56px;">
				<Col span="2">
				</Col>
				<Col span="20" style="text-align: center">
					<Button v-if="!repeatOperation&&!endMeeting&&!concelMeeting" @click="submitMeetingPerson" type="primary" long>提交</Button>
				</Col>
				<Col span="2">
				</Col>
			</Row>
		</div>
		
		<div v-if="repeatOperation||concelMeeting" style="text-align: center;opacity: 0.3;height: 100%;width: 100%;font-size: 40px;position: absolute;left: 0px;top: 0px;">
			<div style="width: 100%;margin: 0 auto;margin-top: 10%; ">
				<Icon size="320" style="margin-top: -12px;" color="#ff5400" :type="repeatOperation?'ios-warning-outline':'ios-close-circle-outline'" />
			</div>
			{{repeatOperation?'请勿重复操作':'会议已取消'}}
		</div>
		
		<div v-if="endMeeting" style="text-align: center;opacity: 0.3;height: 100%;width: 100%;font-size: 40px;position: absolute;left: 0px;top: 0px;">
			<div style="width: 100%;margin: 0 auto;margin-top: 286px;height: 50px;transform:rotate(45deg);">
				会议已结束！
			</div>
		</div>
		<div v-if="AttendSuccess" style="width: 100%;height: 100%;padding-top: 30px;">
			<div style="width: 100%;margin: 0 auto;text-align: center;">
				<Icon size="120" color="#10b910" type="ios-checkmark-circle" />
			</div>
			<div style="width: 100%;height: 38px;margin: 0 auto;text-align: center;font-size: 28px;">
				操作成功
			</div>
		</div>
		
		<div v-if="WarningMsg!=''" style="width: 100%;height: 100%;">
			<div style="width: 100%;margin: 0 auto;text-align: center;margin-top: 30px;">
				<Icon size="120" color="#ed4014" type="ios-alert" />
			</div>
			<div style="width: 100%;height: 38px;margin: 0 auto;text-align: center;font-size: 22px;">
				{{WarningMsg}}
			</div>
		</div>
		<div v-if="Notfound" style="text-align: center;height: 100%;width: 100%;font-size: 40px;position: absolute;left: 0px;top: 0px;">
			<h1 id="not" class="animated flipInX">404</h1>
		</div>
	</div>
</template>
<script>
	import datetimeshow from './expend-datetimeshow';
    export default {
		components: {
			'DateTime': datetimeshow
		},
        data () {
            return {
				AttendSuccess:false,
				repeatOperation:false,
				AttendContextShow:false,
				endMeeting:false,
				concelMeeting:false,
				Notfound:false,
				WarningMsg:'',
				formMeeting:{
					mid:'',
					msubject:'',
					mcrowd:'',
					mdescriptive:'',
					maddress:'',
					mstime:'',
					metime:'',
					mstatus:'',
					mpId:'',
					mremark:'',
					allStatus:true,
					allremark:''
				},
				meetingTimes:[
				],
				meetingPerson:{
					
				}
            }
        },
		created:function(){
			this.$http.get("meetinginfo/ByMidMeetingInfo?mid="+this.$route.query.mid,'').then((res)=> {
				if(res.data.meeting==null){
					this.Notfound=true;
					return ;
				}
				for(let key in res.data.meeting){
					this.formMeeting[key]=res.data.meeting[key];
				}
				let arr=res.data.persons.filter(p=>p.pid==this.$route.query.pid&&p.mid==this.$route.query.mid);	
				if(arr.length<1){
					this.WarningMsg='抱歉，你不是参会人员'
					return ;
				}
				this.meetingPerson=arr[0];
				
				for(let i=0;i<res.data.times.length;i++){
					res.data.times[i].rcase='';
					res.data.times[i].rstatus=true;
					res.data.times[i].mpId=this.meetingPerson.mpId;
					res.data.times[i].mtRegister=res.data.times[i].mtRegister=='00'?true:false;
					this.meetingTimes.push(res.data.times[i]);
				}
				if(this.meetingPerson.mpStatus=='02'){
					this.WarningMsg='抱歉，你不是参会人员';
					return ;
				}else if(this.meetingPerson.mpStatus!='01'){
					this.repeatOperation=true;
					this.AttendContextShow=true;
					return ;
				}
				
				if(this.formMeeting.mstatus=='04'){
					this.concelMeeting=true;
					this.AttendContextShow=true;
					return ;
				}else if(this.formMeeting.mstatus=='03'){
					this.endMeeting=true;
					this.AttendContextShow=true;
					return ;
				}
				
				this.AttendContextShow=true;
				if(this.meetingPerson.mpStatus!='06'){
					this.$http.get("meetingperson/MeetingPersonKnow?mpId="+this.meetingPerson.mpId,'').then((res)=>{
						console.log(res);
					});
				}
				
			});
		},
		methods:{
			submitMeetingPerson(){
				this.AttendContextShow=false;
				this.meetingPerson.mpStatus=this.formMeeting.allStatus?'00':'03';
				for(let i=0;i<this.meetingTimes.length;i++){
					this.meetingTimes[i].rstatus=this.meetingTimes[i].rstatus?'00':'01';
				}
				this.$http.post("meetingperson/operationMeetingPerson",
					{
						person:this.meetingPerson,
						register:this.meetingTimes.filter(mt=>mt.rstatus=='01')
					}
				).then((res)=> {
					if(res.data=='ok'){
						this.AttendSuccess=true;
					}else{
						this.WarningMsg=res.msg;
					}
				});
			}
		},
		computed:{
			register:function(){
				for(let i=0;i<this.meetingTimes.length;i++){
					if(this.meetingTimes[i].mtRegister){
						return true;
					}
				}
				return false;
			}
		},
		watch:{
			'formMeeting.allStatus':{
				handler:function(curVal){
					for(let i=0;i<this.meetingTimes.length;i++){
						this.meetingTimes[i].rstatus=curVal;
					}
	　　　　　　 },
				deep: true,
				immediate: true
			},
			meetingTimes:{
				handler:function(curVal){
					var allTrue=true,allFalse=true;
					for(let i=0;i<curVal.length;i++){
						if(curVal[i].rstatus){
							allFalse=false;
						}else{
							allTrue=false;
						}
					}
					if(allTrue){
						this.formMeeting.allStatus=true;
					}else if(allFalse){
						this.formMeeting.allStatus=false;
					}
	　　　　　　 },
				deep: true
			}
			
		}
    }
</script>
<style scoped lang="less">
	.ivu-table-expanded-cell{
		margin-left: 3px;
	}
	
	#not{
		padding-top: 20%;
		height: 100%;
	    text-align: center;
	    font-size: 4em;
	    font-family: fantasy;
	    color: #475669;
	    letter-spacing: 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Meeting/Attend/index.vue